import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import Close from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import './SlowMotionModal.css'
import TextField from "@material-ui/core/TextField";


const SlowMotionModal = ({ setOpenSlowMotion, slowMotionFunc, timeout }) => {
    const [flowTimeOut, setFlowTimeOut] = useState(1000);
    const { t } = useTranslation();

    useEffect(() => {
        setFlowTimeOut(timeout);
    }, [timeout]);

    const handleClose = () => {
        setOpenSlowMotion(false);
    };

    const handleSubmit = async () => {
        if (flowTimeOut < 1000) {
            return;
        }

        slowMotionFunc(flowTimeOut);
    };

    return (
        <Dialog
            id="import-modal"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden",
                    width: "20%"
                },
            }}
        >
            <DialogTitle
                id="alert-dialog-title"
            >
                <div id="about-title">
                    <b>{t('CONTENT.FLOW.SLOW-MOTION-HEADER')}</b>
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <Grid container spacing={2}>
                        <div className="form-element add-autom-input">
                            <div className="modal-text">{t('CONTENT.FLOW.SLOW-MOTION-TIMEOUT')}</div>
                            <TextField
                                id="filled-size-small"
                                style={{ float: "left" }}
                                className="input"
                                value={flowTimeOut}
                                onChange={(e) => { setFlowTimeOut(e.target.value === '' ? 0 : e.target.value) }}
                                variant="outlined"
                                size="small"
                                type="number"
                                fullWidth
                                inputProps={{ style: { fontSize: 12 } }}
                            />
                            {flowTimeOut < 1000 ? (
                                <small>Please enter over 1000 ms</small>
                            ) : null}
                        </div>
                        <Button
                            disabled={flowTimeOut < 1000}
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                        >
                            {t('CONTENT.ROLE.SAVE')}
                        </Button>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "space-between",
                    padding: "8px 24px 16px 24px",
                }}
            >

            </DialogActions>
        </Dialog>
    );
};

export default SlowMotionModal;
